import { Box } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

/**
 * Single scroll region for auth on viewports below `lg`.
 * Parent shell must be flex column with flex:1 / minHeight:0 — this box is the only vertical scroll container.
 */
export const AuthPageMobile: FC<PropsWithChildren> = ({ children }) => (
    <Box
        component="main"
        sx={{
            flex: 1,
            minHeight: 0,
            position: "relative",
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        }}
    >
        <Box
            sx={{
                flex: 1,
                minHeight: 0,
                overflowX: "hidden",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                overscrollBehaviorY: "contain",
                px: { xs: 2, sm: 3 },
                py: { xs: 4, sm: 8 },
                pb: {
                    xs: "max(32px, env(safe-area-inset-bottom, 0px))",
                    sm: "max(64px, env(safe-area-inset-bottom, 0px))"
                }
            }}
        >
            {children}
        </Box>
    </Box>
);
